import { DESKTOP_MIN_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import ButtonCommon from '../../common/ButtonCommon';
import {
  default as FormResetPasswordExpiredMobile,
  default as FormResetPasswordSuccessMobile,
} from '../components/FormResetPasswordSuccess/mobile';

const FormResetPasswordMobile = ({
  isResetPasswordSuccess,
  isResetPasswordExpired,
  handleSubmit,
  renderPasswordRequires,
  renderFormInputValidations,
}) => {
  const { t } = useLang();

  if (isResetPasswordExpired) {
    return <FormResetPasswordExpiredMobile />;
  }
  if (isResetPasswordSuccess) {
    return <FormResetPasswordSuccessMobile />;
  }
  return (
    <>
      <TitleH3>{t('reset_password_text_reset_password')}</TitleH3>
      <Paragraph>{t('reset_password_text_password_requirements')}</Paragraph>
      {renderPasswordRequires()}
      <FormResetPasswordMobileStyled>
        {renderFormInputValidations()}
        <ConfirmSubmit>
          <ButtonCommon
            value={t('button_confirm')}
            onClick={handleSubmit}
            styles={{
              margin: '0px',
              width: '100%',
            }}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
          />
        </ConfirmSubmit>
      </FormResetPasswordMobileStyled>
    </>
  );
};

const FormResetPasswordMobileStyled = styled(Form)`
  position: relative;
  width: 100%;
  height: fit-content;
  padding-bottom: 96px;
`;

const ConfirmSubmit = styled.div`
  position: fixed;
  bottom: 0px;
  background: var(--ds-c-white);
  width: 100%;
  margin-inline: -24px;
  padding: 16px 24px;
  border-top: 1px solid var(--ds-c-grey-disabled);
`;

const TitleH3 = styled.h3`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 29px;

  color: var(--ds-c-grey-dark);
  margin-bottom: 8px;
`;

const Paragraph = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);
  margin-bottom: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export default FormResetPasswordMobile;
